<div class="app-body tmnz-login-main">
  <main class="main d-flex align-items-center">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 mx-auto">
          <div class="card-group">
            <div class="card p-4">
              <div class="card-body">
                <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <div class="input-group mb-3">
                    <span class="input-group-text"
                      ><i class="icon-user"></i
                    ></span>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="email"
                      placeholder="Email"
                      autocomplete="email"
                      required
                    />
                  </div>
                  <div class="input-group mb-4">
                    <span class="input-group-text"
                      ><i class="icon-lock"></i
                    ></span>
                    <input
                      type="password"
                      class="form-control"
                      formControlName="password"
                      placeholder="Password"
                      autocomplete="current-password"
                      required
                    />
                  </div>

                  <alert
                    class="animated fadeIn"
                    *ngIf="error$ | async"
                    type="danger"
                  >
                    <strong>{{ error$ | async }}</strong>
                  </alert>

                  <app-dots-loader *ngIf="loading; else showbutton">
                  </app-dots-loader>
                  <ng-template #showbutton>
                    <div class="row">
                      <div class="col-6">
                        <button type="submit" class="btn btn-primary px-4">
                          Login
                        </button>
                      </div>
                    </div>
                  </ng-template>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
